import { get } from "lodash";
import { resetStorage } from "../store/dataStore";

/**
 @typedef ResponseData
 @type {{ data: *, status: Status }}
 */

/**
 @typedef Response
 @type {{ data: ResponseData, headers: Headers }}
 */

/**
 @typedef Headers
 @type {{ 'content-type': String }}
 */

/**
 @typedef Status
 @type {{ errorCode: Number }}
 */

/**
 * Interceptor to throw errors if server returns an error with status code 200
 * @param {Response} response - axios response object
 * @returns {Response}
 */
export function responseInterceptor(response) {
  const errorCode = get(response, "data.status.errorCode");
  const errorTitle = get(response, "data.status.error");
  const errorMessage = get(response, "data.status.message");
  const errorData = get(response, "data.data");

  if (errorCode) {
    if (errorCode === 10) {
      resetStorage();
      window.location.replace("/");
    }
    const error = new Error(errorTitle);
    error.errorCode = errorCode;
    error.title = errorMessage;
    error.data = errorData;

    throw error;
  }

  return response;
}
